import moment from 'moment';
require('daterangepicker');
let dt_index = null;
let microsite_id = null;
let form_id = null;
let dt_form_fields = null;
let dt_filled_forms = null;

export function index(params){

    dt_index = $('#forms_table').DataTable({
        ajax: {
            url: $('#forms_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },  
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_forms_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[2, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_forms"]').click(batch_delete_forms);
    });

    microsite_id = params.microsite_id;
}

function render_forms_actions(data, type, row){

    const url_info = ($("#forms_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

export function show(params){

    microsite_id = params.microsite_id;
    form_id = params.form_id;


    show_init_form_fields();
    show_init_filled_forms();
}

function show_init_form_fields(){

    // datatable form_fields
    
    dt_form_fields = $('#form_fields_table').DataTable({
        ajax: {
            url: $('#form_fields_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        autoWidth: false,
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_form_fields_actions },
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true},
            { data: 'label', orderable: true, searchable: true},
            { width: '150', data: 'type', orderable: true, searchable: true},
        ],
        order: [2, 'asc'],
    });

    dt_form_fields.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_form_fields"]').click(batch_delete_form_fields);
    });

    let form = $('#add_form_field');

    let type = form.find('[name="type"]');

    type.on('change', function(){
        show_hide_select_options($(this).val());
    });

    form.on('submit', function(e) {
        e.preventDefault();
        let form = $(this);
        let url = $(this)[0].action;
        let form_data = new FormData($(this)[0]);

        let form_ok = validate_form_data(form_data);        

        if (form_ok) {
            window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null) {
                    
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            break;
                    }

                    if(typeof response.data.redirect != 'undefined'){
                        window.location.href = response.data.redirect;
                    }

                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
                form[0].reset();
                form.closest('.modal').modal('hide');
            });
        }
        form_fields_reload();
    });
}

function show_init_filled_forms(){

    // datatable filled_forms
    
    dt_filled_forms = $('#filled_forms_table').DataTable({
        ajax: {
            url: $('#filled_forms_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        autoWidth: false,
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_filled_forms_actions },
            { width: '120', data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'user_id', orderable: true, searchable: true},
            { data: 'form_content', orderable: true, searchable: true},
        ],
        order: [2, 'desc'],
    });

    dt_filled_forms.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_filled_forms"]').click(batch_delete_filled_forms);
    });

    var start = moment().subtract(29, 'days');
    var end = moment();
 
    function datechange(start, end) {
        $('input[name="daterange"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
        filled_forms_reload();
    }

    function date_export(start, end) {
        $('input[name="export_dates"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
    }

    let date_range_config = {
        locale: {
            format: 'DD/MM/YYYY',
            separator: ' - ',
            applyLabel: window._('Aplicar'),
            cancelLabel: window._('Cancelar'),
            fromLabel: window._('De'),
            toLabel: window._('A'),
            daysOfWeek: [
                window._('Dom'),
                window._('Lun'),
                window._('Mar'),
                window._('Mie'),
                window._('Jue'),
                window._('Vie'),
                window._('Sab'),
            ],
            monthNames: [
                window._('Enero'),
                window._('Febrero'),
                window._('Marzo'),
                window._('Abril'),
                window._('Mayo'),
                window._('Junio'),
                window._('Julio'),
                window._('Agosto'),
                window._('Septiembre'),
                window._('Octubre'),
                window._('Noviembre'),
                window._('Diciembre'),
            ],
            firstDay: 1
        },
        linkedCalendars: false,
        showCustomRangeLabel: false,
        startDate: start,
        endDate: end,
        ranges: {
        'Hoy': [moment(), moment()],
        'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        alwaysShowCalendars : true,
        opens: 'left',
        autoApply: true,
    };

    

    $('input[name="daterange"]').daterangepicker(date_range_config, datechange);

    // datechange(start, end);

    $('#modal_export_filled_forms').on('show.bs.modal', function(event){
        let modal = $(this);
        let select_group_by = modal.find('[name="group_by_export"]');
        let daterange = $('input[name="daterange"]').val();
        let array_dates = daterange.split('-');
        let startDate = array_dates[0].trim().replaceAll('/', '-');
        let endDate = array_dates[1].trim().replaceAll('/', '-');

        select_group_by.find('option[value="'+ $('select[name="group_by"]').val()).prop('selected', true);

        select_group_by.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        $('input[name="export_dates"]').daterangepicker({
            locale: {
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: window._('Aplicar'),
                cancelLabel: window._('Cancelar'),
                fromLabel: window._('De'),
                toLabel: window._('A'),
                daysOfWeek: [
                    window._('Dom'),
                    window._('Lun'),
                    window._('Mar'),
                    window._('Mie'),
                    window._('Jue'),
                    window._('Vie'),
                    window._('Sab'),
                ],
                monthNames: [
                    window._('Enero'),
                    window._('Febrero'),
                    window._('Marzo'),
                    window._('Abril'),
                    window._('Mayo'),
                    window._('Junio'),
                    window._('Julio'),
                    window._('Agosto'),
                    window._('Septiembre'),
                    window._('Octubre'),
                    window._('Noviembre'),
                    window._('Diciembre'),
                ],
                firstDay: 1
            },
            linkedCalendars: false,
            showCustomRangeLabel: false,
            startDate: moment(startDate, 'DD/MM/YYYY'),
            endDate: moment(endDate, 'DD/MM/YYYY'),
            ranges: {
            'Hoy': [moment(), moment()],
            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
            'Este mes': [moment().startOf('month'), moment().endOf('month')],
            'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            alwaysShowCalendars : true,
            opens: 'left',
            autoApply: true,
        }, date_export);
        // modal.find('input[name="export_dates"]').val(daterange);
    });
}

export function filled_forms_reload(){

    dt_filled_forms.ajax.reload();

}

export function filled_forms_force_reload(){

    dt_filled_forms.column(0).checkboxes.deselectAll();
    dt_filled_forms.ajax.reload();

}

function validate_form_data(form_data) {
    let form_ok = true;
    let type = form_data.get('type');

    switch (type) {
        case 'number':
            let min = form_data.get('min');
            let max = form_data.get('max');

            if (min < max) {
                form_ok = true;
            } else {
                form_ok = false;
                window.messages.error(window.__('El valor del campo min ha de ser inferior al campo max'));
            }

            break;
    
        default:
            break;
    }

    return form_ok;
}

function show_hide_select_options(value) {
    switch (value) {
        case 'select':
        case 'checkboxes':
        case 'radio':
            $('textarea[name="options"]').closest('.x-form-input').removeClass('d-none');
            $('input[name="min"]').closest('.x-form-input').addClass('d-none');
            $('input[name="max"]').closest('.x-form-input').addClass('d-none');
            $('input[name="step"]').closest('.x-form-input').addClass('d-none');
            break;
        case 'number':
            $('input[name="min"]').closest('.x-form-input').removeClass('d-none');
            $('input[name="max"]').closest('.x-form-input').removeClass('d-none');
            $('input[name="step"]').closest('.x-form-input').removeClass('d-none');
            $('textarea[name="options"]').closest('.x-form-input').addClass('d-none');
            break;
        default:
            $('textarea[name="options"]').closest('.x-form-input').addClass('d-none');
            $('input[name="min"]').closest('.x-form-input').addClass('d-none');
            $('input[name="max"]').closest('.x-form-input').addClass('d-none');
            $('input[name="step"]').closest('.x-form-input').addClass('d-none');
            break;
    }
}

function render_form_fields_actions(data, type, row){
    const url_info = ($("#form_fields_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_filled_forms_actions(data, type, row){
    const url_info = ($("#filled_forms_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}



//Show de form_field

export function show_form_field(params){

    microsite_id = params.microsite_id;
    form_id = params.form_id;

    let form = $('#edit_form_field');
    let type = form.find('[name="type"]');
    
    type.on('change', function(){
        show_hide_select_options($(this).val());
    });

    show_hide_select_options(type.val());
    
    form.on('submit', function(e) {
        e.preventDefault();
        let url = $(this)[0].action;
        let form_data = new FormData($(this)[0]);

        let form_ok = validate_form_data(form_data);;
        
        if (form_ok) {
            window.forms.post(url, form_data, true, true)
                .then((response) => {
                    if (response.data != null) {
                        switch (response.data.message_level) {
                            case 'error':
                                window.messages.error(response.data.message);
                                break;
                        
                            default:
                                window.messages.info(response.data.message);
                                break;
                        }
                    }
                })
                .catch((error) => {
                    console.log('ERROR', error);
                })
                .finally(() => {
                    window.blockui.release();
                });
            }
    });
}

export function form_fields_reload(){

    dt_form_fields.ajax.reload();

}


function batch_delete_forms(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.forms.batch_delete'].replace('{microsite}', microsite_id);
    
    let forms_id = [];
    $.each(rows_selected, function(index, rowId){
        forms_id.push(rowId);
    });
    
    if(forms_id.length == 0){

        window.messages.error(__('No has seleccionado ningún formulario'));

    } else {

        const title = __('Eliminar formularios');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un formulario.|[2,*] Estás a punto de eliminar :count formularios.', forms_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let form_id of forms_id){
                        formData.append('forms_id[]', form_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );
    }
}
function batch_delete_form_fields(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.forms.batch_delete_form_fields'].replace('{microsite}', microsite_id);
    
    let form_fields_id = [];
    $.each(rows_selected, function(index, rowId){
        form_fields_id.push(rowId);
    });
    
    if(form_fields_id.length == 0){

        window.messages.error(__('No has seleccionado ningún campo'));

    } else {

        const title = __('Eliminar campos del formulario');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un campo del formulario.|[2,*] Estás a punto de eliminar :count campos del formularios.', form_fields_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    formData.append('form_id', form_id);
                    for(let field_id of form_fields_id){
                        formData.append('form_fields_id[]', field_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );
    }
}

function batch_delete_filled_forms(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.forms.batch_delete_filled_forms'].replace('{microsite}', microsite_id);
    
    let filled_forms_id = [];
    $.each(rows_selected, function(index, rowId){
        filled_forms_id.push(rowId);
    });
    
    if(filled_forms_id.length == 0){

        window.messages.error(__('No has seleccionado ningún formulario rellenado'));

    } else {

        const title = __('Eliminar formularios rellenados');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un formulario rellenado.|[2,*] Estás a punto de eliminar :count formularios rellenados.', filled_forms_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    formData.append('form_id', form_id);
                    for(let filled_form_id of filled_forms_id){
                        formData.append('filled_forms_id[]', filled_form_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );
    }
}